import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <CardsSection />
        <IndexSection />
        <FeaturesSection />
        <CarouselSection />
        <AboutSection />
        <RankingSection />
        <ContactSection />
        <UpdatesSection />
        <TopicsSection />
        <AppSection />
        <CommentsSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}